import UIButton from "../atoms/UIButton";
import { Fragment, useEffect, useState } from "react";
import UIModal from "./UIModal";
import { cookies } from "../../services/localContent";

export default function UICookiesAlert() {
    const [cookiesModal, setCookiesModal] = useState(false);
    const [visible, setVisible] = useState(false);

    function gpdrRoutine() { localStorage.setItem('cookies', 'true'); setVisible(false); }
    useEffect(() => { if (localStorage.getItem('cookies') === null) { setTimeout(() => { setVisible(true); }, 1000); } }, []);

    return (
        <Fragment>
            {cookiesModal && <UIModal titleColor="text-primary" title={cookies.title} onClose={() => setCookiesModal(false)} >{cookies.content}</UIModal>}
            <div className="bg-[#353535] rounded-sm z-[999] py-[20px] animate-appear-bottom text-white justify-center items-center gap-[40px] fixed bottom-3 left-3 right-3 px-[10%] flex-col md:flex-row"
                style={{ display: visible ? 'flex' : 'none' }}>
                <div className="max-w-[800px] text-[12px] ">
                    Este sitio usa cookies y otras tecnologías de seguimiento para fines de rendimiento, análisis y marketing. Al usar este sitio web, acepta este uso. Obtenga más información sobre estas tecnologías en la
                    <div onClick={() => setCookiesModal(true)} className="inline ml-2 underline cursor-pointer">
                        Política de privacidad y manejo de cookies.
                    </div>
                </div>
                <UIButton dark onClick={() => gpdrRoutine()} >ACEPTAR</UIButton>
            </div>
        </Fragment>
    )
}